(function ($) {
    $(document.body).on('added_to_cart', function (e, fragments, cart_hash, $button) {
        if (!$button?.length) return;

        $button.next('a.added_to_cart.wc-forward').remove();

        const originalText = $button.data('original-text') || $button.text();

        $button.addClass('is-added').text('Aggiunto');
        setTimeout(function () {
            $button.removeClass('is-added').text(originalText);
        }, 1500);
    });
})(jQuery);